module.exports = __webpack_public_path__ + "img/testImage5.69f07356.69f07356.png";